import { useAuthStore } from '../store/auth.store';

export const clearAllUserData = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('expirationTime');

  useAuthStore.setState({
    user: null,
    accessToken: null,
    refreshToken: null,
    isLoading: false,
    error: null,
    isAuthenticated: false,
    isInitialized: true,
  });
};

export const performLogout = () => {
  clearAllUserData();
  window.location.href = '/login';
};
